import { Component, EventEmitter, Input, Output } from '@angular/core';

import { QualityManagementService } from '../../../../services/quality-management.service';
import { AlertNotificationService } from '../../../../services/alert-notification.service';

import { RiskAttachment } from '../../../../models/entities/risk';

@Component({
  selector: 'risk-action-propose-attachments',
  imports: [],
  templateUrl: './risk-action-propose-attachments.component.html',
  styleUrl: './risk-action-propose-attachments.component.scss'
})
export class RiskActionProposeAttachmentsComponent {

  @Input() riskId?: number | null;
  @Input() riskActionProposeId?: number | null;
  @Input() attachments: RiskAttachment[] = [];
  @Input() readonlyAttachmentsPanel: boolean = false;
  @Input() label: string = 'Evidence';

  @Output() attachmentUploaded = new EventEmitter<void>();

  isUploading: boolean = false;

  constructor(
    private qualityManagementService: QualityManagementService,
    private alertNotificationService: AlertNotificationService
  ) { }

  get canUpload(): boolean {
    return !this.readonlyAttachmentsPanel && !!this.riskId && !!this.riskActionProposeId;
  }

  get currentAttachment(): RiskAttachment | null {
    if (!this.attachments?.length) {
      return null;
    }
    return this.attachments[this.attachments.length - 1];
  }

  get previousAttachments(): RiskAttachment[] {
    if (!this.attachments?.length) {
      return [];
    }
    return this.attachments.slice(0, -1);
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      this.uploadFile(input.files[0]);
      input.value = '';
    }
  }

  downloadFile(file: RiskAttachment): void {
    if (!file?.url) {
      this.alertNotificationService.warning('File URL not available');
      return;
    }

    this.qualityManagementService.attachmentPublicUrl(file.url).subscribe({
      next: (publicUrl: string) => {
        if (!publicUrl) {
          this.alertNotificationService.error('Error downloading file');
          return;
        }
        window.open(publicUrl, '_blank');
      },
      error: (error: any) => {
        console.error('Error downloading the evidence:', error);
        this.alertNotificationService.error('Error downloading file');
      }
    });
  }

  private uploadFile(file: File): void {
    if (!this.canUpload) {
      return;
    }

    this.isUploading = true;

    this.qualityManagementService
      .uploadRiskActionProposeAttachment(Number(this.riskId), Number(this.riskActionProposeId), file)
      .subscribe({
        next: () => {
          this.isUploading = false;
          this.alertNotificationService.success('Evidence uploaded.');
          this.attachmentUploaded.emit();
        },
        error: (error: any) => {
          console.error('Error uploading the evidence:', error);
          this.isUploading = false;
          this.alertNotificationService.error(
            this.qualityManagementService.riskErrorMessage(error, 'Failed to upload the evidence.')
          );
        }
      });
  }
}
